import { size, list } from '../Wrapper';
import { ContainerHelperFunctions } from './Interfaces';
import { rejectValue } from '@egr/xbox/utils/Promise';

export abstract class DirectoryContainer implements ContainerHelperFunctions {
    public constructor(protected basePath: string) {
    }

    public getPath(path: string = ''): string {
        return this.basePath + path;
    }

    public async hasFile(filename: string): Promise<boolean> {
        try {
            await size(this.getPath(filename));
            return true;
        } catch {
            return false;
        }
    }

    public list(path: string): Promise<Array<string>> {
        return rejectValue(list(this.getPath(path)), []);
    }
}